/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryFeeDisinvestmentInstructionsBreakdown
 */
export interface ProposalSummaryFeeDisinvestmentInstructionsBreakdown {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeeDisinvestmentInstructionsBreakdown
     */
    assetCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryFeeDisinvestmentInstructionsBreakdown
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryFeeDisinvestmentInstructionsBreakdown
     */
    splitPercentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryFeeDisinvestmentInstructionsBreakdown interface.
 */
export function instanceOfProposalSummaryFeeDisinvestmentInstructionsBreakdown(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;

    return isInstance;
}

export function ProposalSummaryFeeDisinvestmentInstructionsBreakdownFromJSON(json: any): ProposalSummaryFeeDisinvestmentInstructionsBreakdown {
    return ProposalSummaryFeeDisinvestmentInstructionsBreakdownFromJSONTyped(json, false);
}

export function ProposalSummaryFeeDisinvestmentInstructionsBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryFeeDisinvestmentInstructionsBreakdown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'fundName': json['FundName'],
        'splitPercentage': !exists(json, 'SplitPercentage') ? undefined : json['SplitPercentage'],
    };
}

export function ProposalSummaryFeeDisinvestmentInstructionsBreakdownToJSON(value?: ProposalSummaryFeeDisinvestmentInstructionsBreakdown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'FundName': value.fundName,
        'SplitPercentage': value.splitPercentage,
    };
}

